// extracted by mini-css-extract-plugin
export default {"root":"base-modal_root__RCt2T","title":"base-modal_title__xgxvI","close":"base-modal_close__b8QKX","content":"base-modal_content__DyxR-","actions":"base-modal_actions__g+PFa"};